import {
    ADMIN_OR_MANAGER_ROLES,
    APP_ROLES,
    REPORTS_ROLES,
} from 'entities/User';
import { UserPermissions } from 'entities/User/model/consts/userConsts';
import { AccessDeniedPage } from 'pages/AccessDeniedPage';
import { AddVendorPage } from 'pages/AddVendorPage';
import { AuthRedirectPage } from 'pages/AuthRedirectPage';
import {
    CatalogPage,
    CatalogRootPage,
    LegacyCatalogRedirect,
} from 'pages/CatalogPage';
import {
    CustomListAddItemsCatalog,
    CustomListAddItemsInventory,
    CustomListAddItemsMarketplace,
    CustomListAddItemsPage,
} from 'pages/CustomListAddItemsPage';
import { CustomListPage } from 'pages/CustomListPage';
import { ForbiddenPage } from 'pages/ForbiddenPage';
import { InventoryPage } from 'pages/InventoryPage';
import InventoryCatalogPage from 'pages/InventoryPage/ui/InventoryCatalogPage/InventoryCatalogPage';
import { LoginRedirectPage } from 'pages/LoginRedirectPage';
import { MainPage } from 'pages/MainPage';
import { NotFoundPage } from 'pages/NotFoundPage';
import { OnboardMobileUserPage } from 'pages/OnboardMobileUserPage';
import { OrderAddItemPage } from 'pages/OrderAddItemPage';
import { OrderAddItemPageCatalog } from 'pages/OrderAddItemPage/ui/OrderAddItemPage/OrderAddItemPageCatalog';
import { OrderAddItemPageInventory } from 'pages/OrderAddItemPage/ui/OrderAddItemPage/OrderAddItemPageInventory';
import { OrderAddItemPageLists } from 'pages/OrderAddItemPage/ui/OrderAddItemPage/OrderAddItemPageLists';
import { OrderMarketplacePage } from 'pages/OrderAddItemPage/ui/OrderAddItemPage/OrderMarketplacePage';
import { OrderViewPage } from 'pages/OrderViewPage';
import { OrdersPage } from 'pages/OrdersPage';
import { PrivacyPolicyEmbededPage } from 'pages/PrivacyPolicyEmbededPage';
import { PrivacyPolicyPage } from 'pages/PrivacyPolicyPage';
import { ProfilePage } from 'pages/ProfilePage';
import { PropertiesPage } from 'pages/PropertiesPage';
import { PropertiesItem } from 'pages/PropertiesPage/ui/PropertyItem';
import {
    PropertyCatManagementPage,
    PropertyCatalogPage,
} from 'pages/PropertyCatalogPage';
import { PropertyInfoPage } from 'pages/PropertyInfoPage';
import { ReportsMainPage } from 'pages/ReportsMainPage';
import { ReportsPageCategory } from 'pages/ReportsPageByCategory';
import { ReportsPageSavingsSummary } from 'pages/ReportsPageSavingsSummary';
import { ReportsPageSavingsSummaryCategory } from 'pages/ReportsPageSavingsSummaryCategory';
import { ReportsPageSavingsSummaryProduct } from 'pages/ReportsPageSavingsSummaryProduct';
import { ReportsPageSavingsSummaryProperty } from 'pages/ReportsPageSavingsSummaryProperty';
import { ReportsPageSpendSummary } from 'pages/ReportsPageSpendSummary';
import { ReportsPageSpendSummaryCategory } from 'pages/ReportsPageSpendSummaryCategory';
import { ReportsPageSpendSummaryProduct } from 'pages/ReportsPageSpendSummaryProduct';
import { ReportsPageSpendSummaryProperty } from 'pages/ReportsPageSpendSummaryProperty';
import { ReportsPageSpendSummarySupplier } from 'pages/ReportsPageSpendSummarySupplier';
import { SettingsPage } from 'pages/SettingsMainPage';
import { SettingsOrdersDeliveryPage } from 'pages/SettingsOrdersDeliveryPage';
import { SettingsOrdersPage } from 'pages/SettingsOrdersPage';
import { SettingsOrdersSavingsPage } from 'pages/SettingsOrdersSavingsPage';
import { SettingsOrdersSourcingPage } from 'pages/SettingsOrdersSourcingPage';
import { SupplierPage } from 'pages/SupplierPage';
import { TermsOfServiceEmbededPage } from 'pages/TermsOfServiceEmbededPage';
import { TermsOfServicePage } from 'pages/TermsOfServicePage';
import { VendorsMainPage } from 'pages/VendorsMainPage';
import {
    AppRoutes,
    getOnboardMobile,
    getRouteAccessDenied,
    getRouteAddVendors,
    getRouteAuth,
    getRouteCatalog,
    getRouteCatalogRoot,
    getRouteForbidden,
    getRouteLogin,
    getRouteMain,
    getRouteMainReports,
    getRouteMainVendors,
    getRouteNotFound,
    getRouteOrderCatalogCategoriesItem,
    getRouteOrderMarketplaceCategory,
    getRouteOrderMarketplaceItem,
    getRouteOrders,
    getRouteOrdersAddItems,
    getRouteOrdersAddItemsCategories,
    getRouteOrdersAddItemsInventory,
    getRouteOrdersAddItemsList,
    getRouteOrdersAddItemsLists,
    getRouteOrdersAddItemsMarketplace,
    getRouteOrdersTable,
    getRouteOrdersTableByStatus,
    getRouteOrdersView,
    getRouteOrdersViewItemDetailed,
    getRoutePrivacyPolicy,
    getRoutePrivacyPolicyEmbeded,
    getRouteProfile,
    getRouteProperties,
    getRoutePropertiesCatalog,
    getRoutePropertiesItem,
    getRouteReportsByCategory,
    getRouteReportsSavingsSummary,
    getRouteReportsSavingsSummaryCategory,
    getRouteReportsSavingsSummaryProduct,
    getRouteReportsSavingsSummaryProperty,
    getRouteReportsSpendSummary,
    getRouteReportsSpendSummaryCategory,
    getRouteReportsSpendSummaryProduct,
    getRouteReportsSpendSummaryProperty,
    getRouteReportsSpendSummarySupplier,
    getRouteSettings,
    getRouteSettingsOrdersDelivery,
    getRouteSettingsOrdersSavings,
    getRouteSettingsOrdersSourcing,
    getRouteTermsOfService,
    getRouteTermsOfServiceEmbeded,
    getRouteVendorsSupplierPage,
} from 'shared/const/router';
import { AppRoutesProps } from 'shared/types/router';
import { OrderViewItemDetailed } from 'widgets/OrderViewItemDetailed';
import { OrdersTable } from 'widgets/OrdersTable';
import { OrdersTableGrid } from 'widgets/OrdersTable/ui/OrdersTableGrid';
import {
    PropertyCatalogItemDataDefinerOutlet,
    PropertyCatalogItemsOutlet,
} from 'widgets/PropertyCatalog';

export const routeConfig: Partial<Record<AppRoutes, AppRoutesProps>> = {
    [AppRoutes.CATALOG_ROOT]: {
        path: getRouteCatalogRoot(),
        element: <CatalogRootPage />,
        roles: APP_ROLES,
        authOnly: true,
    },
    [AppRoutes.CATALOG]: {
        path: getRouteCatalog(':propertyId'),
        element: <CatalogPage />,
        roles: APP_ROLES,
        authOnly: true,
        nested: {
            [AppRoutes.CATALOG_PAGE]: {
                element: <PropertyCatalogPage />,
                nested: {
                    // Same URL as /catalog/:propertyId (relative empty path)
                    [AppRoutes.CATALOG_MANAGEMENT]: {
                        path: '',
                        element: <PropertyCatManagementPage />,
                        nested: {
                            [AppRoutes.CATALOG_ITEMS]: {
                                path: ':categoryId',
                                element: <PropertyCatalogItemsOutlet />,
                            },
                            [AppRoutes.CATALOG_ITEM]: {
                                path: ':categoryId/item/:itemId',
                                element: (
                                    <PropertyCatalogItemDataDefinerOutlet />
                                ),
                            },
                        },
                    },
                    [AppRoutes.CATALOG_GLOBAL]: {
                        path: 'global',
                        element: <PropertyCatManagementPage />,
                        nested: {
                            [AppRoutes.CATALOG_GLOBAL_ITEMS]: {
                                path: ':categoryId',
                                element: <PropertyCatalogItemsOutlet />,
                            },
                            [AppRoutes.CATALOG_GLOBAL_ITEM]: {
                                path: ':categoryId/item/:itemId',
                                element: (
                                    <PropertyCatalogItemDataDefinerOutlet />
                                ),
                            },
                        },
                    },
                    [AppRoutes.CATALOG_INVENTORY]: {
                        path: 'inventory',
                        element: <InventoryPage />,
                        nested: {
                            [AppRoutes.CATALOG_INVENTORY_ITEM]: {
                                path: ':itemId',
                                element: (
                                    <PropertyCatalogItemDataDefinerOutlet />
                                ),
                            },
                        },
                    },
                    [AppRoutes.CATALOG_INVENTORY_CATEGORIES]: {
                        path: 'inventory/categories',
                        element: <InventoryCatalogPage />,
                        nested: {
                            [AppRoutes.CATALOG_INVENTORY_CATEGORIES_ITEMS]: {
                                path: ':categoryId',
                                element: <PropertyCatalogItemsOutlet />,
                            },
                        },
                    },
                    [AppRoutes.CATALOG_LIST]: {
                        path: 'lists/:listId',
                        element: <CustomListPage />,
                        nested: {
                            [AppRoutes.CATALOG_LIST_ITEM]: {
                                path: 'item/:itemId',
                                element: (
                                    <PropertyCatalogItemDataDefinerOutlet />
                                ),
                            },
                        },
                    },
                    [AppRoutes.CATALOG_LIST_ADD_ITEMS]: {
                        path: 'lists/:listId/add-items',
                        element: <CustomListAddItemsPage />,
                        nested: {
                            [AppRoutes.CATALOG_LIST_ADD_ITEMS_CATEGORIES]: {
                                path: 'categories',
                                element: <CustomListAddItemsCatalog />,
                                nested: {
                                    [AppRoutes.CATALOG_LIST_ADD_ITEMS_CATEGORIES]:
                                        {
                                            path: '',
                                            element: (
                                                <PropertyCatalogItemsOutlet />
                                            ),
                                        },
                                    [AppRoutes.CATALOG_LIST_ADD_ITEMS_CATEGORIES_DETAILED]:
                                        {
                                            path: ':itemId',
                                            element: (
                                                <PropertyCatalogItemDataDefinerOutlet />
                                            ),
                                        },
                                },
                            },
                            [AppRoutes.CATALOG_LIST_ADD_ITEMS_INVENTORY]: {
                                path: 'inventory',
                                element: <CustomListAddItemsInventory />,
                                nested: {
                                    [AppRoutes.CATALOG_LIST_ADD_ITEMS_INVENTORY_DETAILED]:
                                        {
                                            path: ':itemId',
                                            element: (
                                                <PropertyCatalogItemDataDefinerOutlet />
                                            ),
                                        },
                                },
                            },
                            [AppRoutes.CATALOG_LIST_ADD_ITEMS_MARKETPLACE]: {
                                path: 'marketplace',
                                element: <CustomListAddItemsMarketplace />,
                                nested: {
                                    [AppRoutes.CATALOG_LIST_ADD_ITEMS_MARKETPLACE_CATEGORY]:
                                        {
                                            path: ':categoryId',
                                            element: (
                                                <PropertyCatalogItemsOutlet />
                                            ),
                                        },
                                    [AppRoutes.CATALOG_LIST_ADD_ITEMS_MARKETPLACE_DETAILED]:
                                        {
                                            path: ':categoryId/item/:itemId',
                                            element: (
                                                <PropertyCatalogItemDataDefinerOutlet />
                                            ),
                                        },
                                },
                            },
                        },
                    },
                },
            },
        },
    },
    [AppRoutes.PROPERTIES]: {
        path: getRouteProperties(),
        element: <PropertiesPage />,
        roles: APP_ROLES,
        authOnly: true,
        nested: {
            [AppRoutes.PROPERTIES_ITEM]: {
                path: getRoutePropertiesItem(':propertyId'),
                element: <PropertiesItem />,
                nested: {
                    [AppRoutes.PROPERTIES_INFO]: {
                        path: '',
                        element: <PropertyInfoPage />,
                    },
                },
            },
        },
    },
    [AppRoutes.PROPERTIES_LEGACY_CATALOG_REDIRECT]: {
        path: `${getRoutePropertiesCatalog(':propertyId')}/*`,
        element: <LegacyCatalogRedirect />,
        roles: APP_ROLES,
        authOnly: true,
    },
    [AppRoutes.ORDERS]: {
        path: getRouteOrders(),
        element: <OrdersPage />,
        roles: APP_ROLES,
        authOnly: true,
        nested: {
            [AppRoutes.ORDERS_TABLE]: {
                path: getRouteOrdersTable(':propertyId'),
                element: <OrdersTable />,
                nested: {
                    [AppRoutes.ORDERS_TABLE_STATUS]: {
                        path: getRouteOrdersTableByStatus(
                            ':propertyId',
                            ':orderStatus',
                        ),
                        element: <OrdersTableGrid />,
                    },
                },
            },
        },
    },
    [AppRoutes.ORDERS_ADD_ITEMS]: {
        path: getRouteOrdersAddItems(),
        element: <OrderAddItemPage />,
        roles: APP_ROLES,
        nested: {
            [AppRoutes.ORDERS_ADD_ITEMS_CATEGORIES]: {
                path: getRouteOrdersAddItemsCategories(),
                element: <OrderAddItemPageCatalog />,
                nested: {
                    [AppRoutes.ORDERS_ADD_ITEMS_CATEGORIES]: {
                        path: getRouteOrdersAddItemsCategories(),
                        element: <PropertyCatalogItemsOutlet />,
                    },
                    [AppRoutes.ORDERS_ADD_ITEMS_CATEGORIES_DETAILED]: {
                        path: getRouteOrderCatalogCategoriesItem(':itemId'),
                        element: <PropertyCatalogItemDataDefinerOutlet />,
                    },
                },
            },
            [AppRoutes.ORDERS_ADD_ITEMS_INVENTORY]: {
                path: getRouteOrdersAddItemsInventory(),
                element: <OrderAddItemPageInventory />,
            },
            [AppRoutes.ORDERS_ADD_ITEMS_LISTS]: {
                path: getRouteOrdersAddItemsLists(),
                element: <OrderAddItemPageLists />,
            },
            [AppRoutes.ORDERS_ADD_ITEMS_LIST]: {
                path: getRouteOrdersAddItemsList(':listId'),
                element: <OrderAddItemPageLists />,
            },
            [AppRoutes.ORDERS_ADD_ITEMS_MARKETPLACE]: {
                path: getRouteOrdersAddItemsMarketplace(),
                element: <OrderMarketplacePage />,
                nested: {
                    [AppRoutes.ORDERS_ADD_ITEMS_MARKETPLACE]: {
                        path: getRouteOrderMarketplaceCategory(':categoryId'),
                        element: <PropertyCatalogItemsOutlet />,
                    },
                    [AppRoutes.ORDERS_ADD_ITEMS_MARKETPLACE_DETAILED]: {
                        path: getRouteOrderMarketplaceItem(
                            ':categoryId',
                            ':itemId',
                        ),
                        element: <PropertyCatalogItemDataDefinerOutlet />,
                    },
                },
            },
        },
        authOnly: true,
    },
    [AppRoutes.ORDERS_VIEW]: {
        path: getRouteOrdersView(':orderId'),
        element: <OrderViewPage />,
        roles: APP_ROLES,
        authOnly: true,
        nested: {
            [AppRoutes.ORDERS_VIEW_ITEM_DETAILED]: {
                path: getRouteOrdersViewItemDetailed(':orderId', ':itemId'),
                element: <OrderViewItemDetailed />,
            },
        },
    },
    [AppRoutes.VENDORS]: {
        path: getRouteMainVendors(':propertyId'),
        element: <VendorsMainPage />,
        roles: APP_ROLES,
        authOnly: true,
    },
    [AppRoutes.VENDORS_SUPPLIER_PAGE]: {
        path: getRouteVendorsSupplierPage(':supplierId', ':propertyId'),
        element: <SupplierPage />,
        roles: APP_ROLES,
        authOnly: true,
    },
    [AppRoutes.ADD_VENDORS_PAGE]: {
        path: getRouteAddVendors(':propertyId'),
        element: <AddVendorPage />,
        roles: ADMIN_OR_MANAGER_ROLES,
        authOnly: true,
    },
    [AppRoutes.REPORTS]: {
        path: getRouteMainReports(),
        element: <ReportsMainPage />,
        roles: REPORTS_ROLES,
        authOnly: true,
    },
    [AppRoutes.REPORTS_BY_CATEGORY]: {
        path: getRouteReportsByCategory(),
        element: <ReportsPageCategory />,
        roles: REPORTS_ROLES,
        authOnly: true,
    },
    [AppRoutes.REPORTS_SAVINGS_SUMMARY]: {
        path: getRouteReportsSavingsSummary(),
        element: <ReportsPageSavingsSummary />,
        permission: UserPermissions.API_SEE_SAVINGS_INSIGHTS,
        authOnly: true,
    },
    [AppRoutes.REPORTS_SAVINGS_PRODUCT_DRILLIN]: {
        path: getRouteReportsSavingsSummaryProduct(':sku'),
        element: <ReportsPageSavingsSummaryProduct />,
        permission: UserPermissions.API_SEE_SAVINGS_INSIGHTS,
        authOnly: true,
    },
    [AppRoutes.REPORTS_SAVINGS_PROPERTY_DRILLIN]: {
        path: getRouteReportsSavingsSummaryProperty(':propertyId'),
        element: <ReportsPageSavingsSummaryProperty />,
        permission: UserPermissions.API_SEE_SAVINGS_INSIGHTS,
        authOnly: true,
    },
    [AppRoutes.REPORTS_SAVINGS_CATEGORY_DRILLIN]: {
        path: getRouteReportsSavingsSummaryCategory(':categoryId'),
        element: <ReportsPageSavingsSummaryCategory />,
        permission: UserPermissions.API_SEE_SAVINGS_INSIGHTS,
        authOnly: true,
    },
    [AppRoutes.REPORTS_SPEND_SUMMARY]: {
        path: getRouteReportsSpendSummary(),
        element: <ReportsPageSpendSummary />,
        permission: UserPermissions.API_SEE_SPEND_INSIGHTS,
        authOnly: true,
    },
    [AppRoutes.REPORTS_SPEND_PRODUCT_DRILLIN]: {
        path: getRouteReportsSpendSummaryProduct(':sku'),
        element: <ReportsPageSpendSummaryProduct />,
        permission: UserPermissions.API_SEE_SPEND_INSIGHTS,
        authOnly: true,
    },
    [AppRoutes.REPORTS_SPEND_PROPERTY_DRILLIN]: {
        path: getRouteReportsSpendSummaryProperty(':propertyId'),
        element: <ReportsPageSpendSummaryProperty />,
        permission: UserPermissions.API_SEE_SPEND_INSIGHTS,
        authOnly: true,
    },
    [AppRoutes.REPORTS_SPEND_CATEGORY_DRILLIN]: {
        path: getRouteReportsSpendSummaryCategory(':categoryId'),
        element: <ReportsPageSpendSummaryCategory />,
        permission: UserPermissions.API_SEE_SPEND_INSIGHTS,
        authOnly: true,
    },
    [AppRoutes.REPORTS_SPEND_SUPPLIER_DRILLIN]: {
        path: getRouteReportsSpendSummarySupplier(':supplierId'),
        element: <ReportsPageSpendSummarySupplier />,
        permission: UserPermissions.API_SEE_SPEND_INSIGHTS,
        authOnly: true,
    },
    [AppRoutes.SETTINGS]: {
        path: getRouteSettings(),
        element: <SettingsPage />,
        roles: ADMIN_OR_MANAGER_ROLES,
        authOnly: true,
    },
    [AppRoutes.SETTINGS_ORDERS]: {
        path: getRouteSettingsOrdersSourcing(':propertyId', ':orderType'),
        element: <SettingsOrdersPage />,
        roles: ADMIN_OR_MANAGER_ROLES,
        authOnly: true,
        nested: {
            [AppRoutes.SETTINGS_ORDERS_SOURCING]: {
                path: getRouteSettingsOrdersSourcing(
                    ':propertyId',
                    ':orderType',
                ),
                element: <SettingsOrdersSourcingPage />,
            },
            [AppRoutes.SETTINGS_ORDERS_DELIVERY]: {
                path: getRouteSettingsOrdersDelivery(
                    ':propertyId',
                    ':orderType',
                ),
                element: <SettingsOrdersDeliveryPage />,
            },
            [AppRoutes.SETTINGS_ORDERS_SAVINGS]: {
                path: getRouteSettingsOrdersSavings(
                    ':propertyId',
                    ':orderType',
                ),
                element: <SettingsOrdersSavingsPage />,
            },
        },
    },
    [AppRoutes.MAIN]: {
        path: getRouteMain(),
        element: <MainPage />,
    },
    [AppRoutes.ONBOARD_MOBILE]: {
        path: getOnboardMobile(),
        element: <OnboardMobileUserPage />,
        // temp
        // will be added real role
        // roles: [UserRole.PREONBOARD],
    },
    [AppRoutes.LOGIN]: {
        path: getRouteLogin(),
        element: <LoginRedirectPage />,
    },
    [AppRoutes.AUTH]: {
        path: getRouteAuth(),
        element: <AuthRedirectPage />,
    },
    [AppRoutes.PROFILE]: {
        path: getRouteProfile(),
        element: <ProfilePage />,
        authOnly: true,
    },
    [AppRoutes.PRIVACY_POLICY]: {
        path: getRoutePrivacyPolicy(),
        element: <PrivacyPolicyPage />,
    },
    [AppRoutes.TERMS_OF_SERVICE]: {
        path: getRouteTermsOfService(),
        element: <TermsOfServicePage />,
    },
    [AppRoutes.PRIVACY_POLICY_EMBEDED]: {
        path: getRoutePrivacyPolicyEmbeded(),
        element: <PrivacyPolicyEmbededPage />,
    },
    [AppRoutes.TERMS_OF_SERVICE_EMBEDED]: {
        path: getRouteTermsOfServiceEmbeded(),
        element: <TermsOfServiceEmbededPage />,
    },
    // error pages
    [AppRoutes.FORBIDDEN]: {
        authOnly: true,
        path: getRouteForbidden(),
        element: <ForbiddenPage />,
    },
    [AppRoutes.ACCESS_DENIED]: {
        path: getRouteAccessDenied(),
        element: <AccessDeniedPage />,
    },
    [AppRoutes.NOT_FOUND_PAGE]: {
        path: getRouteNotFound(),
        element: <NotFoundPage />,
    },
    // last
    [AppRoutes.NOT_FOUND]: {
        path: '*',
        element: <NotFoundPage />,
    },
};
